import type { FC, ReactNode } from 'react'

import { Reveal } from '@/components/motion/reveal'
import { milestones } from '@/constants/about'

export const AboutEducation: FC = (): ReactNode => {
    return (
        <section
            id='education'
            className='relative z-[2] flex w-full flex-col items-center gap-10 overflow-clip bg-background px-4 py-section-sm lg:px-6'
        >
            <div className='flex w-full justify-start gap-6'>
                <h2 className='flex w-full flex-1 flex-wrap items-center gap-1.5 py-6 pr-6 text-foreground md:max-w-[60%]'>
                    <span className='t-label whitespace-nowrap'>
                        Education
                    </span>

                    <span className='t-italic whitespace-pre'>
                        and
                    </span>

                    <span className='t-label text-left'>
                        Certifications
                    </span>
                </h2>
            </div>

            <div className='flex w-full justify-end gap-6'>
                <div aria-hidden='true' className='hidden max-w-[32%] flex-1 self-stretch py-6 pr-6 lg:block' />

                <ul className='flex w-full flex-col gap-5 md:max-w-[68%] lg:max-w-none lg:flex-1'>
                    {milestones.map((milestone, index) => (
                        <li key={`${milestone.year}-${milestone.title}`}>
                            <Reveal y={20} delay={index * 0.04}>
                                <div className='flex items-start gap-6 border-b border-border pb-4 text-foreground'>
                                    <div className='max-w-[12%] flex-1 self-stretch pt-1.5'>
                                        <p className='t-italic text-left'>
                                            {milestone.year}
                                        </p>
                                    </div>

                                    <div className='flex min-w-0 flex-1 flex-col gap-1 md:flex-row md:gap-12'>
                                        <p className='t-body text-left md:max-w-[34%] md:flex-1'>
                                            {milestone.category}
                                        </p>

                                        <p className='t-body text-left text-muted-foreground md:flex-1'>
                                            {milestone.title}
                                        </p>
                                    </div>
                                </div>
                            </Reveal>
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    )
}
